<template>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-column">
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>Asset History {{getDataTitle()}}</h1>
        </span>
        <v-progress-circular indeterminate color="success" v-if="loader"/>
        <v-card outlined v-for="(record, i) of data" :key="i" class="d-flex flex-column mb-2">
          <v-card-title class="d-flex flex-row justify-space-between">
            <span>
              <span>
                {{record.recordType.toUpperCase()}}
              </span>
              <span v-if="record.recordType==='item'">
                <span>Owned By: {{record.Customer.firstName||''}} {{record.Customer.lastName||''}}{{record.Customer.phone?' | '+record.Customer.phone:''}}{{record.Customer.email?' | '+record.Customer.email:''}}</span>
                <span> | Colour: {{record.colour}}</span>
              </span>
              <span v-if="record.recordType==='appointment'">
                <span>For: {{record.Customer.firstName||''}} {{record.Customer.lastName||''}}{{record.Customer.phone?' | '+record.Customer.phone:''}}{{record.Customer.email?' | '+record.Customer.email:''}}</span>
                <span> | scheduled for {{helpers.customFormatDate(record.scheduledFor)}}</span>
              </span>
            </span>
            <span><span style="font-size: 12px; font-weight: normal">Last Updated At: </span>{{helpers.customFormatDate(record.updatedAt)}}</span>
          </v-card-title>
          <v-card-text class="d-flex flex-column">
            <span>{{record.recordType.toUpperCase()}} ID: {{record.id}}</span>

            <span v-if="record.recordType==='asset'" class="d-flex flex-row flex-wrap">
              <span class="mr-5">Style: {{record.styleNo}}</span>
              <span class="mr-5">Created At: {{helpers.customFormatDate(record.createdAt)}}</span>
              <span class="mr-5">Updated At: {{helpers.customFormatDate(record.updatedAt)}}</span>
            </span>

            <span v-if="record.recordType==='item'">
              <h3>Jobs</h3>
              <span class="d-flex flex-row flex-wrap">
                <v-card class="col-3 mr-2" outlined v-for="(job, j) of record.Jobs" :key="j">
                  <v-card-text class="d-flex flex-column">
                    <span>Job ID: {{job.id}}</span>
                    <span>Transaction: {{job.transactionId}}</span>
                    <span>Status: {{helpers.parseJobStatus(job.status)}}</span>
                    <span v-if="job.dateOut">Date Out: {{helpers.customFormatDate(job.dateOut)}}</span>
                    <span v-if="job.dateIn">Date In: {{helpers.customFormatDate(job.dateIn)}}</span>
                    <span v-if="job.sentAt">Sent At: {{helpers.customFormatDate(job.sentAt)}} by {{lookupUsername(job.sentBy)}}</span>
                    <span v-if="job.receivedAt">Received At: {{helpers.customFormatDate(job.receivedAt)}} by {{lookupUsername(job.receivedBy)}}</span>
                    <span v-if="job.dateToHand">Date To Hand: {{helpers.customFormatDate(job.dateToHand)}}</span>
                    <span v-if="job.handedOffAt">Handed Off At: {{helpers.customFormatDate(job.handedOffAt)}} by {{lookupUsername(job.handedOffBy)}}</span>
                    <span v-if="job.voidAt">Voided At: {{helpers.customFormatDate(job.voidAt)}} by {{lookupUsername(job.voidBy)}}</span>
                    <span v-if="job.Appointment" class="d-flex flex-column">
                      <h3>Appointment</h3>
                      <span class="d-flex flex-column">
                        <span>ID: {{job.Appointment.id}}</span>
                        <span>Scheduled For: {{helpers.customFormatDate(job.Appointment.scheduledFor)}}</span>
                        <span>Status: {{helpers.parseAppointmentStatus(job.Appointment.status)}}</span>
                        <span>Finished At: {{helpers.customFormatDate(job.Appointment.finishedAt)}} by {{lookupUsername(job.Appointment.finishedBy)}}</span>
                        <span>Sealed At: {{helpers.customFormatDate(job.Appointment.sealedAt)}} by {{lookupUsername(job.Appointment.sealedBy)}}</span>
                      </span>
                    </span>
                  </v-card-text>
                </v-card>
              </span>
            </span>

            <span v-if="record.recordType==='appointment'" class="d-flex flex-column">
              <span>Scheduled For: {{helpers.customFormatDate(record.scheduledFor)}}</span>
              <span>Status: {{helpers.parseAppointmentStatus(record.status)}}</span>
              <span>Finished At: {{helpers.customFormatDate(record.finishedAt)}} by {{lookupUsername(record.finishedBy)}}</span>
              <span>Sealed At: {{helpers.customFormatDate(record.sealedAt)}} by {{lookupUsername(record.sealedBy)}}</span>
              <span v-if="record.AppointmentAssetJoins && record.AppointmentAssetJoins.length>0">
                <h3>Engagements</h3>
                <span class="d-flex flex-row flex-wrap">
                  <v-card class="col-3 mr-2" outlined v-for="(eng, j) of record.AppointmentAssetJoins" :key="j">
                    <v-card-text class="d-flex flex-column">
                      <span>Customer {{getActivityType(eng.activityType)}} {{eng.Asset.styleNo}}.</span>
                      <span v-if="eng.metadata && eng.metadata.createdBy">Created By: {{lookupUsername(eng.metadata.createdBy)}}</span>
                      <span>Recorded At {{helpers.customFormatDate(eng.updatedAt)}}</span>
                      <span v-if="eng.notes">Notes: {{eng.notes}}</span>
                    </v-card-text>
                  </v-card>
                </span>
              </span>
              <span v-if="record.Jobs && record.Jobs.length>0">
                <h3>Jobs</h3>
                <span class="d-flex flex-row flex-wrap">
                  <v-card class="col-3 mr-2" outlined v-for="(job, j) of record.Jobs" :key="j">
                    <v-card-text class="d-flex flex-column">
                      <span>Job ID: {{job.id}}</span>
                      <span>Transaction: {{job.transactionId}}</span>
                      <span>Status: {{helpers.parseJobStatus(job.status)}}</span>
                      <span v-if="job.dateOut">Date Out: {{helpers.customFormatDate(job.dateOut)}}</span>
                      <span v-if="job.dateIn">Date In: {{helpers.customFormatDate(job.dateIn)}}</span>
                      <span v-if="job.sentAt">Sent At: {{helpers.customFormatDate(job.sentAt)}} by {{lookupUsername(job.sentBy)}}</span>
                      <span v-if="job.receivedAt">Received At: {{helpers.customFormatDate(job.receivedAt)}} by {{lookupUsername(job.receivedBy)}}</span>
                      <span v-if="job.dateToHand">Date To Hand: {{helpers.customFormatDate(job.dateToHand)}}</span>
                      <span v-if="job.handedOffAt">Handed Off At: {{helpers.customFormatDate(job.handedOffAt)}} by {{lookupUsername(job.handedOffBy)}}</span>
                      <span v-if="job.voidAt">Voided At: {{helpers.customFormatDate(job.voidAt)}} by {{lookupUsername(job.voidBy)}}</span>
                      <span v-if="job.Appointment" class="d-flex flex-column">
                        <h3>Appointment</h3>
                        <span class="d-flex flex-column">
                          <span>ID: {{job.Appointment.id}}</span>
                          <span>Scheduled For: {{helpers.customFormatDate(job.Appointment.scheduledFor)}}</span>
                          <span>Status: {{helpers.parseAppointmentStatus(job.Appointment.status)}}</span>
                          <span>Finished At: {{helpers.customFormatDate(job.Appointment.finishedAt)}} by {{lookupUsername(job.Appointment.finishedBy)}}</span>
                          <span>Sealed At: {{helpers.customFormatDate(job.Appointment.sealedAt)}} by {{lookupUsername(job.Appointment.sealedBy)}}</span>
                        </span>
                      </span>
                    </v-card-text>
                  </v-card>
                </span>
              </span>
            </span>
          </v-card-text>
        </v-card>
        <br>
      </v-col>
    </v-row>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import helpers from "../../plugins/helpers";
export default {
  data () {
    return {
      helpers: helpers,
      isEditable: false,

      loader: true,
      data: null,

      snackObj: {
        color: '',
        text: ''
      },
    }
  },
  async mounted(){
    await this.getAllData();
  },
  computed: {
    ...mapGetters(['getEndpoint', 'lookupUsername'])
  },
  methods: {
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    async getAllData(){
      try {
        this.loader = true;
        let res = await axios.get(`${this.getEndpoint}/api/reports/assetHistory/${this.$route.params.assetId}`)
        if(res.data.error) throw res.data.error;
        this.data = res.data.data;

        console.log(this.data)
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    getActivityType(activity){
      switch(activity){
        case 2:
          return "Tried"
        case 1:
          return "Viewed"
        case 4:
          return "Purchased"
        default:
          return "Unknown"
      }
    },
    getDataTitle(){
      if(!this.data) return ''

      let asset = this.data.find(x => x.recordType==='asset');
      if(!asset) return '';

      return ` For ${asset.styleNo} (ID: ${asset.id})`
    }
  }
}
</script>
